"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addCapabilities = exports.onboardCapabilities = exports.editCapabilities = exports.DashboardCapabilities = exports.DaysOfWeekFullNames = void 0;
exports.DaysOfWeekFullNames = {
    mon: 'Monday',
    tue: 'Tuesday',
    wed: 'Wednesday',
    thu: 'Thursday',
    fri: 'Friday',
    sat: 'Saturday',
    sun: 'Sunday'
};
/**
 * Fine-grained control of context-sensitive features to be shown/hidden
 * Make sure to keep the documentation up-to-date if this changes
 * https://www.notion.so/travelnest/Capabilities-7ff83f502ee54c25867ef1956b5d1813
 */
var DashboardCapabilities;
(function (DashboardCapabilities) {
    DashboardCapabilities[DashboardCapabilities["None"] = 0] = "None";
    DashboardCapabilities[DashboardCapabilities["BedsBathsAmenities"] = 1] = "BedsBathsAmenities";
    DashboardCapabilities[DashboardCapabilities["ArrivalsHouseRules"] = 2] = "ArrivalsHouseRules";
    DashboardCapabilities[DashboardCapabilities["PricingFees"] = 4] = "PricingFees";
    DashboardCapabilities[DashboardCapabilities["PhotosDescriptionAvailability"] = 8] = "PhotosDescriptionAvailability";
    DashboardCapabilities[DashboardCapabilities["Channels"] = 16] = "Channels";
    DashboardCapabilities[DashboardCapabilities["Account"] = 32] = "Account";
    DashboardCapabilities[DashboardCapabilities["OnboardCopyContext"] = 64] = "OnboardCopyContext";
    DashboardCapabilities[DashboardCapabilities["EditCopyContext"] = 128] = "EditCopyContext";
    DashboardCapabilities[DashboardCapabilities["AddCopyContext"] = 256] = "AddCopyContext";
    DashboardCapabilities[DashboardCapabilities["ShowPublish"] = 512] = "ShowPublish";
    DashboardCapabilities[DashboardCapabilities["HeaderNavigation"] = 1024] = "HeaderNavigation";
    DashboardCapabilities[DashboardCapabilities["UnpublishedChangesPrompt"] = 2048] = "UnpublishedChangesPrompt";
    DashboardCapabilities[DashboardCapabilities["FurtherPropertyActionLinks"] = 4096] = "FurtherPropertyActionLinks";
    DashboardCapabilities[DashboardCapabilities["RecordTaskCompletionFacts"] = 8192] = "RecordTaskCompletionFacts";
    DashboardCapabilities[DashboardCapabilities["RequireSectionReviews"] = 16384] = "RequireSectionReviews";
    DashboardCapabilities[DashboardCapabilities["AllowChannelSelection"] = 32768] = "AllowChannelSelection";
    DashboardCapabilities[DashboardCapabilities["ShowCommissionDetails"] = 65536] = "ShowCommissionDetails";
    DashboardCapabilities[DashboardCapabilities["RequireTermsAndConditions"] = 131072] = "RequireTermsAndConditions";
    DashboardCapabilities[DashboardCapabilities["RequirePersonalDetails"] = 262144] = "RequirePersonalDetails";
    DashboardCapabilities[DashboardCapabilities["DisablePricing"] = 524288] = "DisablePricing";
    DashboardCapabilities[DashboardCapabilities["DisableTaskNavigator"] = 1048576] = "DisableTaskNavigator";
    DashboardCapabilities[DashboardCapabilities["DisableAvailability"] = 2097152] = "DisableAvailability";
    DashboardCapabilities[DashboardCapabilities["ShortPublish"] = 4194304] = "ShortPublish";
    DashboardCapabilities[DashboardCapabilities["VerifyOnPublish"] = 8388608] = "VerifyOnPublish";
    DashboardCapabilities[DashboardCapabilities["RecordOnboardCompleteFact"] = 16777216] = "RecordOnboardCompleteFact";
    DashboardCapabilities[DashboardCapabilities["RecordTaskCompleteTrackingEvents"] = 33554432] = "RecordTaskCompleteTrackingEvents";
    DashboardCapabilities[DashboardCapabilities["PublishWithoutLocalLicence"] = 67108864] = "PublishWithoutLocalLicence";
    DashboardCapabilities[DashboardCapabilities["RequirePropertyVerification"] = 134217728] = "RequirePropertyVerification";
})(DashboardCapabilities = exports.DashboardCapabilities || (exports.DashboardCapabilities = {}));
exports.editCapabilities = DashboardCapabilities.BedsBathsAmenities
    | DashboardCapabilities.ArrivalsHouseRules
    | DashboardCapabilities.PricingFees
    | DashboardCapabilities.PhotosDescriptionAvailability
    | DashboardCapabilities.EditCopyContext
    | DashboardCapabilities.ShowPublish
    | DashboardCapabilities.UnpublishedChangesPrompt
    | DashboardCapabilities.FurtherPropertyActionLinks
    | DashboardCapabilities.DisableTaskNavigator
    | DashboardCapabilities.ShortPublish
    | DashboardCapabilities.PublishWithoutLocalLicence;
exports.onboardCapabilities = DashboardCapabilities.BedsBathsAmenities
    | DashboardCapabilities.ArrivalsHouseRules
    | DashboardCapabilities.PricingFees
    | DashboardCapabilities.PhotosDescriptionAvailability
    | DashboardCapabilities.Channels
    | DashboardCapabilities.Account
    | DashboardCapabilities.OnboardCopyContext
    | DashboardCapabilities.ShowPublish
    | DashboardCapabilities.RecordTaskCompletionFacts
    | DashboardCapabilities.RequireSectionReviews
    | DashboardCapabilities.AllowChannelSelection
    | DashboardCapabilities.ShowCommissionDetails
    | DashboardCapabilities.RequireTermsAndConditions
    | DashboardCapabilities.RequirePersonalDetails
    | DashboardCapabilities.VerifyOnPublish
    | DashboardCapabilities.RecordOnboardCompleteFact
    | DashboardCapabilities.RecordTaskCompleteTrackingEvents
    | DashboardCapabilities.RequirePropertyVerification;
exports.addCapabilities = DashboardCapabilities.BedsBathsAmenities
    | DashboardCapabilities.ArrivalsHouseRules
    | DashboardCapabilities.PricingFees
    | DashboardCapabilities.PhotosDescriptionAvailability
    | DashboardCapabilities.AddCopyContext
    | DashboardCapabilities.ShowPublish
    | DashboardCapabilities.HeaderNavigation
    | DashboardCapabilities.RecordTaskCompletionFacts
    | DashboardCapabilities.RequireSectionReviews
    | DashboardCapabilities.ShortPublish
    | DashboardCapabilities.RequirePropertyVerification;
//# sourceMappingURL=index.js.map